import { render, staticRenderFns } from "./ForgoPassword.vue?vue&type=template&id=ba05a73c&scoped=true&"
import script from "./ForgoPassword.vue?vue&type=script&lang=ts&"
export * from "./ForgoPassword.vue?vue&type=script&lang=ts&"
import style0 from "./ForgoPassword.vue?vue&type=style&index=0&id=ba05a73c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba05a73c",
  null
  
)

export default component.exports